var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('v-card',{staticClass:"area-login pa-0"},[_c('h1',{staticClass:"login-title"},[_vm._v("ログイン / 新規登録")]),_c('div',{attrs:{"id":"firebaseui-auth-container"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }